




import Vue from "vue";
import processingRequestsList from "@/components/processing-requests/processing-requests-list.component.vue";
export default Vue.extend({
  components: {
    "processing-requests-list": processingRequestsList,
  },
});
